export default __webpack_public_path__ + "static/media/usdc.e6e5e560.svg";